module.exports = __webpack_public_path__ + "static/media/update-bac.a08781b0.svg";